import type {
  VolunteerSlotStatusUpdateRequest,
  VolunteerSlotStatusUpdateResponse,
} from '@sola/schema/dotcom/supporters/volunteers.ts';
import { userErrorBadParam } from '@sola/shared-utils/errors/misc.ts';
import {
  httpPatchWithStatus,
  isErrorResponse,
  isSuccessStatus,
} from '@sola/shared-utils/httpClient.ts';
import type { ErrorResponse } from '@sola/shared-utils/httpClient.ts';

import { MY_API_BASE } from '../constants.ts';

export const routeVolunteerSlots = (supporterId: string) =>
  `${MY_API_BASE}/supporters/${supporterId}/volunteer/slots/`;

/**
 * Update one or more volunteer slot statuses for a supporter.
 */
export const updateVolunteerSlots = async (
  supporterId: string | undefined,
  updates: VolunteerSlotStatusUpdateRequest[],
): Promise<VolunteerSlotStatusUpdateResponse> => {
  if (!supporterId) {
    throw userErrorBadParam('supporterId');
  }

  if (!updates.length) {
    throw userErrorBadParam('updates');
  }

  const { response, statusCode } = await httpPatchWithStatus<
    VolunteerSlotStatusUpdateResponse | ErrorResponse
  >(routeVolunteerSlots(supporterId), updates, { signRequest: true });

  if (!isSuccessStatus(statusCode) || !response || isErrorResponse(response)) {
    throw new Error('Failed to update volunteer slots');
  }

  return response;
};
